<script>
import CardImg from './CardImg';

export default {

    name: 'CardImgTop',

    extends: CardImg
};
</script>
